import '../sass/app.scss';
import "@babel/polyfill";
import { VueModule } from './modules/vue';
import { I18nModule } from './modules/i18n';

// Charger les fichiers javascripts globaux.
require('./bootstrap');

I18nModule.init();

VueModule.init();